import React, { CSSProperties, Ref } from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import Flex from '@cobalt/react-flex';
import Input from '@cobalt/react-input';
import Box from '@cobalt/react-box';
import Label from '@cobalt/react-label';
import { Text } from '@cobalt/react-typography';
import Required from '@cobalt/react-required';

import CheckboxGroup from './CheckboxGroup';

export interface CheckboxProps {
  id?: string | false;
  label?: string;
  checked?: boolean | string;
  disabled?: boolean;
  required?: boolean;
  truncated?: boolean;
  className?: string;
  style?: CSSProperties;
  prefixCls?: string;
  onChange?: (checked: boolean) => void;
  onBlur?: () => void;
  forwardedRef?: Ref<HTMLInputElement>;
}

const cls = 'checkbox';

function Checkbox(props: CheckboxProps) {
  const {
    id = uuid(),
    label = '',
    checked = false,
    disabled = false,
    required = false,
    truncated = true,
    className,
    style,
    prefixCls = 'cobalt',
    onChange,
    onBlur,
    forwardedRef,
  } = props;

  const componentCls = `${prefixCls}-${cls}`;
  const mergeClassNames = classNames(`${componentCls}`, className);

  return (
    <Flex className={mergeClassNames} style={{ maxWidth: '100%', ...style }}>
      <Input
        forwardedRef={forwardedRef}
        id={typeof id === 'string' ? id : undefined}
        type="checkbox"
        value={checked as string}
        checked={checked as boolean}
        disabled={disabled}
        onChange={() => onChange?.(!checked)}
        onBlur={onBlur}
      />

      {label && (
        <Flex style={{ overflowX: 'hidden' }} alignY="center" paddingLeft="2" grow>
          <Box style={{ overflowX: 'hidden' }}>
            <Label htmlFor={typeof id === 'string' ? id : ''}>
              <Text truncated={truncated} title={truncated ? label : undefined}>
                {label}
              </Text>
            </Label>
          </Box>

          {required && (
            <Box paddingLeft="1">
              <Required title="required" />
            </Box>
          )}
        </Flex>
      )}
    </Flex>
  );
}

Checkbox.Group = CheckboxGroup;

export default Checkbox;
